import ToggleViewContainer from "../../../Components/Buttons/ToggleButton";
import Nfa from "../RealizationStatics/Nfa";
import { TqpStatus } from "../RealizationStatics/PricingAnalysis";
const NfaRegionCombined = ({ show }) => {
  return (
    <ToggleViewContainer
      show={show}
      leftLabel="Region Wise Realization"
      rightLabel="NFA Status"
      LeftComponent={Nfa}
      RightComponent={TqpStatus}
      defaultLeft={true}
    />
  );
};

export default NfaRegionCombined;
